import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { attachNetworkQualityInterceptor } from '@/utils/networkQualityMonitor'

const configurationClient = axios.create({

    baseURL: process.env.VUE_APP_AUTHENTICATION_URL,

    // Requerido para que el browser envíe la cookie sherpa_device_trust en cada login
    withCredentials: true,

})

attachNetworkQualityInterceptor(configurationClient)

configurationClient.interceptors.request.use(config => {
    //config.headers.Authorization = `Bearer ${store.getters['auth/getToken']}`
    config.headers.lang   = store.getters['getLang']
    config.headers.Accept = 'application/json'
    return config;
})

// ── Interceptor de respuesta 2FA ──────────────────────────────────────────────
// Si el session_token expira (401) mientras el usuario está en el flujo 2FA,
// limpiamos el estado y redirigimos al login con un mensaje de aviso.
configurationClient.interceptors.response.use(
    response => response,
    error => {
        const status       = error.response?.status
        const isPending2FA = store.state.auth?.pendingTwoFactor

        if (status === 401 && isPending2FA) {
            store.commit('auth/CLEAR_TWO_FACTOR')
            router.push({ name: 'auth-login', query: { expired: '1' } })
        }

        return Promise.reject(error)
    }
)
// ─────────────────────────────────────────────────────────────────────────────

export default configurationClient